import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LoginHeaderComponent } from './login-header.component';

@NgModule({
  declarations: [LoginHeaderComponent],
  imports: [CommonModule],
  exports: [LoginHeaderComponent]
})
export class LoginHeaderModule {}
